import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CallState } from '@lcs/shared/api';
import { ExceptionType } from 'src/app/common-components/errors/models/error-message';
import { ErrorMessageService } from 'src/app/common-components/errors/services/error-message.service';
import { PasswordFormService } from 'src/app/common-components/password-form-control/password-form.service';
import { UserPasswordResetFormValue } from '../models/user-password-reset.form';
import { UserPasswordResetModel } from '../models/user-password-reset.model';
import { userPasswordResetSubmitted } from '../state/user-password-reset.actions';
import { getUserPasswordResetCallState } from '../state/user-password-reset.selectors';

@Component({
    encapsulation: ViewEncapsulation.None,
    providers: [PasswordFormService],
    selector: 'ndt-user-password-reset',
    templateUrl: './user-password-reset.component.html',
    standalone: false
})
export class UserPasswordResetComponent implements OnInit {
   loading$: Observable<CallState>;

   token: string | null;

   constructor(
      private store: Store,
      private activatedRoute: ActivatedRoute,
      private errorMessageService: ErrorMessageService
   ) {}

   ngOnInit(): void {
      this.token = this.activatedRoute.snapshot.queryParamMap.get('token');
      this.loading$ = this.store.pipe(select(getUserPasswordResetCallState));
   }

   onSubmit(userPasswordResetForm: UserPasswordResetFormValue): void {
      if (this.token) {
         const token: string = this.token;
         const userPasswordReset: UserPasswordResetModel = {
            confirmPassword: userPasswordResetForm.confirmNewPassword,
            encryptedToken: token,
            password: userPasswordResetForm.newPassword,
         };
         this.store.dispatch(userPasswordResetSubmitted({ userPasswordReset }));
      } else {
         this.showMissingTokenError();
      }
   }

   private showMissingTokenError() {
      this.errorMessageService.openErrorDialog({
         // eslint-disable-next-line @typescript-eslint/naming-convention
         UserMessage: 'No token was provided in the url',
         exceptionType: ExceptionType.ErrorMessage,
         userMessage: '',
      });
   }
}
